/**
 * 线框提取服务接口
 */
export interface WireFrameExtractService {
    /**
     * 执行线框提取操作
     * @param options - 线框提取参数
     * @returns 线框提取结果
     */
    extract(options: WireFrameExtractOptions): Promise<WireFrameExtractResult>;
}

export const WireFrameExtractService = Symbol('WireFrameExtractService');

/**
 * 线框提取参数
 */
export interface WireFrameExtractOptions {
    /** S3 键值 */
    s3Key: string;
    /** Base64 图像数据 */
    base64ImageData?: string;
}

/**
 * 线框提取结果
 */
export interface WireFrameExtractResult {
    /** 图形ID */
    figureId: string;
    /** 任务ID */
    taskId: string;
    /** 线框图URL */
    wireframeUrl: string;
    /** 线框图S3键值 */
    wireframeS3Key: string;
    /** 剩余次数 */
    remainingCount: number;
}
